<div class="logo">
  <svg
    class="hexagon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 346.4 400"
    style="enable-background:new 0 0 346.4 400;"
    xml:space="preserve"
  >
    <polygon
      fill="black"
      points="173.2,0 0,100 0,300 173.2,400 346.4,300 346.4,100 "
    />
  </svg>
  <svg
    class="c"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 346.4 400"
    style="enable-background:new 0 0 346.4 400;"
    xml:space="preserve"
  >
    <path
      fill="white"
      d="M172,149.1c30.9,0,63.5,10.3,74.7,31.1h18.1v-44.9h-18.6v18.8c-14.3-12.3-38.7-22.4-77.8-22.4c-61.1,0-89.5,35.4-89.5,65.8
  c0,42.5,35.1,69.1,97.5,69.1c64.3,0,89.5-24.4,91.1-54.4h-17.7c-1.8,17.9-18.5,36.7-72.7,36.7c-50.7,0-74-19-74-51.2
  C103.1,165,137.1,149.1,172,149.1z"
    />
  </svg>
</div>

<style>
  .logo {
    position: relative;

    display: inline-block;

    vertical-align: -webkit-baseline-middle;
    vertical-align: middle;
    height: 2.35rem;
    width: 2.35rem;
    margin-top: -4px;
  }
  .hexagon {
    position: absolute;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .c {
    position: absolute;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .hexagon {
    transition: transform 400ms cubic-bezier(0.5, 0, 0.5, 1.666667);
  }

  :global(.with-logo:hover .hexagon) {
    transform: rotate(60deg);
  }
</style>
